import classNames from 'classnames';
import { memo } from 'react';

import { Plus } from '@air/next-icons';

import { SELECT_CREATE_OPTION } from '~/components/Select/shared/testIDs';

type SelectCreateOptionProps = {
  onClick: () => void;
  value: string;
  hideSpacer: boolean;
  createVerb?: string;
};

export const SelectCreateOption = memo(
  ({ onClick, hideSpacer, value, createVerb = 'Create' }: SelectCreateOptionProps) => {
    return (
      <li
        className={classNames('w-full', hideSpacer ? 'mt-0 border-t-none' : 'mt-2 border-t border-t-grey-5')}
        data-testid={SELECT_CREATE_OPTION}
        onClick={onClick}
      >
        <div className={classNames('w-full', hideSpacer ? 'mt-0' : 'mt-2')}>
          <div
            className={classNames(
              'flex w-full cursor-pointer items-center justify-start',
              hideSpacer ? 'mt-0' : 'mt-3',
            )}
          >
            <Plus className="size-4 text-grey-11" />
            <div className="ml-1.5 font-medium text-14 text-grey-11">{`${createVerb} "${value}"?`}</div>
          </div>
        </div>
      </li>
    );
  },
);

SelectCreateOption.displayName = 'SelectCreateOption';
